<template>
  <div class="all-work__search">
    <img class="all-work__search-icon" src="/res/subdomains/img/all-work__search-icon.svg" alt="all-work__search-icon"/>
    <input v-model="name"
           v-on:blur="set_name(name_in)" v-on:keyup.enter="set_name(name_in)"
           class="all-work__input" type="text" :placeholder="$t('message.Search')"
           onfocus="$(this).parents('.all-work__boxes:first').addClass('is-active')"
           onblur="$(this).parents('.all-work__boxes:first').removeClass('is-active')"/>
  </div>
</template>


<script>
  import FilterSearchMix from "../../../../../components/list/filter/FilterSearchMix";

  export default {
    name   : 'filter-search-sub',
    mixins: [FilterSearchMix],
  }
</script>



// WEBPACK FOOTER //
// src/sub/_common/components/list/filter/FilterSearchSub.vue